import React, { Component } from "react";
import ReportV1 from "./ReportV1";

// V2 IS CURRENTLY DISABLED - every questionnaire gets the V1 report.
//
// To re-enable, restore the commented-out code below: it resolves the
// questionnaire type from the report payload and mounts ReportV2 for type 2.
// Everything V2 needs is still in place (pages/report/ReportV2.js, the
// components in pages/report/v2/ and the typeId field in the report action),
// so this is the only file that has to change.
//
// import ReportV2 from "./ReportV2";
// import { Loader } from "../../components";
// import { getLanguage } from "../../utils/utils";
// import API from "../../api";
//
// // Questionnaire type that gets the V2 report layout.
// const V2_TYPE_ID = 2;

export default class ReportRouter extends Component {
  render() {
    return <ReportV1 {...this.props} />;
  }
}

// The type-resolving version of the component above. It fetches the report once
// to read info.typeId, then mounts the matching variant - the variants cannot
// borrow each other's renderReport(), because their helpers are class fields
// that live on the instance rather than the prototype.
//
// export default class ReportRouter extends Component {
//   constructor(props) {
//     super(props);
//
//     this.state = {
//       typeId: undefined,
//     };
//   }
//
//   componentDidMount() {
//     this.loadType();
//   }
//
//   loadType = async () => {
//     await API.get("", {
//       params: {
//         id: this.props.match.params.id,
//         action: "report",
//         language: getLanguage(),
//       },
//     })
//       .then((response) => {
//         this.setState({
//           typeId:
//             response.data && response.data.info
//               ? response.data.info.typeId
//               : null,
//         });
//       })
//       .catch(() => {
//         // Fall back to the original layout rather than showing nothing.
//         this.setState({ typeId: null });
//       });
//   };
//
//   render() {
//     const { typeId } = this.state;
//
//     if (typeId === undefined) {
//       return <Loader />;
//     }
//
//     return typeId === V2_TYPE_ID ? (
//       <ReportV2 {...this.props} />
//     ) : (
//       <ReportV1 {...this.props} />
//     );
//   }
// }
